/**
 * A view which presents username and password fields to the user.
 *
 * ## Fields
 * Name | Description
 * --- | ---
 * username | The value of the username field. This field is **readonly**.
 * password | The value of the password field. This field is **readonly**.
 */
import Backbone from "backbone";
import _ from "underscore";
import FormInputView from "core/views/FormInputView";
import Field from "core/models/Field";
export default Backbone.View.extend({
  tagName: "form",
  className: "login-view",
  template: _.template(
    '<% if(message){%><p><%- message%></p><% }%><% if(error){%><p class="bg-danger"><%- error%></p><% }%>'
  ),

  initialize: function (options) {
    Backbone.View.prototype.initialize.apply(this, arguments);

    this.options = _.defaults({}, options, {
      error: false,
      message: false,
    });
    this._model = new Backbone.Model({
      username: "",
      password: "",
    });
    this._fields = [
      new Field({
        id: "username",
        name: "username",
        label: "Username",
        editor: "text",
      }),
      new Field({
        id: "password",
        name: "password",
        label: "Password",
        editor: "password",
      }),
    ];

    var self = this;

    Object.defineProperty(this, "username", {
      get: function () {
        return self._model.get("username");
      },
      set: function (value) {
        self._model.set("username", value);
      },
    });
    Object.defineProperty(this, "password", {
      get: function () {
        return self._model.get("password");
      },
      set: function (value) {
        self._model.set("password", value);
      },
    });
    Object.defineProperty(this, "error", {
      get: function () {
        return self.$(".bg-danger").html() || "";
      },
      set: function (value) {
        self.$(".bg-danger").html(value);
      },
    });
  },

  render: function () {
    var inputViews = _.map(
      this._fields,
      function (field) {
        return new FormInputView({
          model: this._model,
          field: field,
        });
      },
      this
    );

    this.$el.html(this.template(this.options));
    _.each(
      inputViews,
      function (inputView) {
        inputView.render();
        this.$el.append(inputView.$el);
      },
      this
    );
  },
});



//////////////////
// WEBPACK FOOTER
// ./public/js/app/views/LoginView.js
// module id = 865
// module chunks = 1